export interface PlanLabel {
  id: string;
  name: string;
}

export interface DisplayCriteria {
  segments: string[];
}

export interface FullPlanLabel extends PlanLabel {
  displayCriteria: DisplayCriteria;
  description?: string;
}

export enum PlanRecordsEvents {
  GroupSave = 'group_save',
}

export enum AccountPlanRecordStatus {
  Active = 'active',
  Inactive = 'inactive',
}
export interface AccountPlanRecord {
  id: string;
  accountId: string;
  event: PlanRecordsEvents;
  meta: Record<string, unknown>;
  status: AccountPlanRecordStatus;
  dateCreated: Date;
}

export enum MyPlanRequestStatus {
  Start = 'start',
  InProgress = 'inProgress',
  Done = 'done',
}
